import React from "react";

import * as reviewCardStyles from "./review.module.scss";
import { Rating } from '@mantine/core';
import { getImage } from "gatsby-plugin-image";

export default function Review({ item }) {
  return (
    <a href={item.link || '#'} target="_blank" className={reviewCardStyles.reviewCard}>
      {item?.elementImage?.image && 
        <div>
          <img src={getImage(item.elementImage.image.localFile).images.fallback.src} alt={item.elementImage.image.altText || 'N/A'} />
        </div>
      }
      <div className={reviewCardStyles.reviewCard__review}>
        <div className={reviewCardStyles.reviewCard__rating}>{`${item?.ratingValue}/5.0` || 'N/A'}</div>
        {item?.ratingValue &&
          <div className={reviewCardStyles.reviewCard__stars}>
            <Rating value={item.ratingValue} fractions={10} readOnly />
          </div>
        }
      </div>
    </a>
  );
}
